import { render, staticRenderFns } from "./PaymentExpiryDate.vue?vue&type=template&id=bf473220&"
import script from "./PaymentExpiryDate.vue?vue&type=script&lang=js&"
export * from "./PaymentExpiryDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports